import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { BaseActionRendererProps, PriorityData, getActionData } from "./BaseActionRenderer";

export const PriorityActionRenderer: React.FC<BaseActionRendererProps> = ({ actionData }) => {
  const priorityData = getActionData(actionData) as PriorityData;

  const title = priorityData.title || actionData.title || "New Priority";
  const description = priorityData.description;
  const category = priorityData.category;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" sx={{ fontWeight: 500 }} gutterBottom>
        Priority: {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ mb: 1, fontStyle: "italic" }}>
          {description}
        </Typography>
      )}

      {category && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Category:
          </Typography>
          <Chip label={category} size="small" color="primary" variant="outlined" />
        </Box>
      )}

      {actionData.reason && (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
          Reason: {actionData.reason}
        </Typography>
      )}
    </Box>
  );
};
